module.exports = __webpack_public_path__ + "static/media/lc.efc6f02c.svg";